import * as ambassadorWixRestaurantsV3Order from './restaurants-v3-order-orders.http.js';
import * as ambassadorWixRestaurantsV3OrderTypes from './restaurants-v3-order-orders.types.js';
import * as ambassadorWixRestaurantsV3OrderUniversalTypes from './restaurants-v3-order-orders.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getOrder(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixRestaurantsV3OrderUniversalTypes.GetOrderRequest,
  ambassadorWixRestaurantsV3OrderTypes.GetOrderRequest,
  ambassadorWixRestaurantsV3OrderUniversalTypes.GetOrderResponse,
  ambassadorWixRestaurantsV3OrderTypes.GetOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixRestaurantsV3Order.getOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/orders/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listOrders(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsV3OrderUniversalTypes.ListOrdersRequest,
  ambassadorWixRestaurantsV3OrderTypes.ListOrdersRequest,
  ambassadorWixRestaurantsV3OrderUniversalTypes.ListOrdersResponse,
  ambassadorWixRestaurantsV3OrderTypes.ListOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixRestaurantsV3Order.listOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function acceptOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixRestaurantsV3OrderUniversalTypes.AcceptOrderRequest,
  ambassadorWixRestaurantsV3OrderTypes.AcceptOrderRequest,
  ambassadorWixRestaurantsV3OrderUniversalTypes.AcceptOrderResponse,
  ambassadorWixRestaurantsV3OrderTypes.AcceptOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV3Order.acceptOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/orders/{id}/accept',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixRestaurantsV3OrderUniversalTypes.CancelOrderRequest,
  ambassadorWixRestaurantsV3OrderTypes.CancelOrderRequest,
  ambassadorWixRestaurantsV3OrderUniversalTypes.CancelOrderResponse,
  ambassadorWixRestaurantsV3OrderTypes.CancelOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV3Order.cancelOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/orders/{id}/cancel',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function fulfillOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixRestaurantsV3OrderUniversalTypes.FulfillOrderRequest,
  ambassadorWixRestaurantsV3OrderTypes.FulfillOrderRequest,
  ambassadorWixRestaurantsV3OrderUniversalTypes.FulfillOrderResponse,
  ambassadorWixRestaurantsV3OrderTypes.FulfillOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV3Order.fulfillOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/orders/{id}/fulfill',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Order as OrderOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  LineItem as LineItemOriginal,
  LineItemOption as LineItemOptionOriginal,
  DisplayType as DisplayTypeOriginal,
  DisplayTypeWithLiterals as DisplayTypeWithLiteralsOriginal,
  LineItemOptionItem as LineItemOptionItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  Discount as DiscountOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Coupon as CouponOriginal,
  Payment as PaymentOriginal,
  PaymentType as PaymentTypeOriginal,
  PaymentTypeWithLiterals as PaymentTypeWithLiteralsOriginal,
  Fulfillment as FulfillmentOriginal,
  FulfillmentDetailsOneOf as FulfillmentDetailsOneOfOriginal,
  FulfillmentType as FulfillmentTypeOriginal,
  FulfillmentTypeWithLiterals as FulfillmentTypeWithLiteralsOriginal,
  DeliveryDetails as DeliveryDetailsOriginal,
  DeliveryDetailsProviderOneOf as DeliveryDetailsProviderOneOfOriginal,
  DeliveryAddress as DeliveryAddressOriginal,
  OnArrival as OnArrivalOriginal,
  OnArrivalWithLiterals as OnArrivalWithLiteralsOriginal,
  DeliveryAddressLocation as DeliveryAddressLocationOriginal,
  Restaurant as RestaurantOriginal,
  ExternalProvider as ExternalProviderOriginal,
  PickupInfo as PickupInfoOriginal,
  DropOffInfo as DropOffInfoOriginal,
  PickupDetails as PickupDetailsOriginal,
  Curbside as CurbsideOriginal,
  DineInDetails as DineInDetailsOriginal,
  Customer as CustomerOriginal,
  CustomerIdOneOf as CustomerIdOneOfOriginal,
  Totals as TotalsOriginal,
  ServiceFee as ServiceFeeOriginal,
  Money as MoneyOriginal,
  Activity as ActivityOriginal,
  ChannelInfo as ChannelInfoOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  LoyaltyInfo as LoyaltyInfoOriginal,
  PosInfo as PosInfoOriginal,
  Error as ErrorOriginal,
  PosInfoExternalProvider as PosInfoExternalProviderOriginal,
  GetTotalActiveOrdersRequest as GetTotalActiveOrdersRequestOriginal,
  GetTotalActiveOrdersResponse as GetTotalActiveOrdersResponseOriginal,
  LocationToAmount as LocationToAmountOriginal,
  NotifyOrderEventRequest as NotifyOrderEventRequestOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  Empty as EmptyOriginal,
  GetOrderByMsidRequest as GetOrderByMsidRequestOriginal,
  GetOrderByMsidResponse as GetOrderByMsidResponseOriginal,
  ListOrdersByMsidRequest as ListOrdersByMsidRequestOriginal,
  Sort as SortOriginal,
  FieldName as FieldNameOriginal,
  FieldNameWithLiterals as FieldNameWithLiteralsOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  ListOrdersByMsidResponse as ListOrdersByMsidResponseOriginal,
  NotifyOrderEventResponse as NotifyOrderEventResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  NewOrder as NewOrderOriginal,
  GetOrderRequest as GetOrderRequestOriginal,
  GetOrderResponse as GetOrderResponseOriginal,
  ListOrdersRequest as ListOrdersRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListOrdersResponse as ListOrdersResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  AcceptOrderRequest as AcceptOrderRequestOriginal,
  AcceptOrderRequestDeliveryTimeOneOf as AcceptOrderRequestDeliveryTimeOneOfOriginal,
  AcceptOrderResponse as AcceptOrderResponseOriginal,
  OrderAccepted as OrderAcceptedOriginal,
  CancelOrderRequest as CancelOrderRequestOriginal,
  CancelOrderResponse as CancelOrderResponseOriginal,
  OrderCanceled as OrderCanceledOriginal,
  FulfillOrderRequest as FulfillOrderRequestOriginal,
  FulfillOrderResponse as FulfillOrderResponseOriginal,
  OrderFulfilled as OrderFulfilledOriginal,
  CountOrdersRequest as CountOrdersRequestOriginal,
  CountOrdersQuery as CountOrdersQueryOriginal,
  DateRangeFilter as DateRangeFilterOriginal,
  CountOrdersResponse as CountOrdersResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
} from './restaurants-v3-order-orders.types.js';
